<template>
  <vs-row vs-justify="center" vs-w="12">
    <vs-col vs-w="12">
      <vs-select
        width="100%"
        v-model="localChooseType"
        v-on:change="$emit('change-choose-type', localChooseType)"
      >
        <vs-select-item :value="0" :text="'Selecione'" />
        <vs-select-item
          v-bind:value="type.CODIGO"
          v-for="type in types"
          :key="type.CODIGO"
          :text="`${type.CODIGO} - ${type.NOME}`"
        />
      </vs-select>
    </vs-col>
  </vs-row>
</template>

<script>
import MailingService from '../services/mailing'

export default {
  name: 'SelectedMailingBox',
  props: [
    "chooseType",
  ],
  data: () => ({
    types: null,
    localChooseType: 0,
  }),
  created() {
    this.$vs.loading()
    this.localChooseType = this.chooseType
    new MailingService().getTypes()
      .then(res => {
        this.types = res.data
      })
      .catch(error => {
        this.$emit("api-error", "Erro ao se comunicar com o servidor. " + (error?.response?.data?.error || ""))
      })
      .finally(() => {
        this.$vs.loading.close()
      })
  },
  watch: {
    chooseType(value) {
      this.localChooseType = value
    }
  }
}
</script>

<style>
</style>
